export default async function CreateTopPlanApi(
  title,
  description,
  unitId,
  target,
  targetDate,
  scaleId,
  scaleUnitId,
  assignTo,
  performanceCycleId,
  planGroupId,
  canExceed,
  attributes,
  positionId,
  approverId
) {
  let res = "";
  try {
    const body = {
      title: title,
      description: description || "",
      unitId: unitId,
      target: target,
      targetDate: targetDate || "",
      scaleId: scaleId,
      scaleUnitId: scaleUnitId,
      assignTo: assignTo,
      performanceCycleId: performanceCycleId,
      planGroupId: planGroupId,
      canExceed: canExceed,
      attributes: attributes,
      positionId: positionId,
      approverId: approverId,
    };
    const token = "Bearer " + localStorage.getItem("authToken");
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
        Authorization: token,
      },
      body: JSON.stringify(body),
    };
    await fetch(
      `${process.env.REACT_APP_API_URL}v1/plans/top-level-plan`,
      requestOptions
    )
      .then((response) => response.json())
      .then((response) => {
        res = response;
      })
      .catch((error) => {
        console.error("Error create plan: ", error);
        res = error;
      });
  } catch (error) {
    console.error(error);
    res = error;
  }

  return res;
}
